export enum FurthestFutureInviteUnitEnum {
  DAY = 'DAY',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

export enum EntryOptionsEnum {
  SINGLE_ENTRY = 'SINGLE_ENTRY',
  DOUBLE_ENTRY = 'DOUBLE_ENTRY',
  UNLIMITED = 'UNLIMITED',
}

export enum VisitorContactRequirementType {
  EMAIL_AND_PHONE = 'EMAIL_AND_PHONE',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  EMAIL_OR_PHONE = 'EMAIL_OR_PHONE',
  NONE = 'NONE',
}

export enum CheckInOption {
  STOP_AT_DESK = 'STOP_AT_DESK',
  BYPASS_DESK = 'BYPASS_DESK',
  BOTH = 'BOTH',
}

export enum DefaultCheckInOption {
  STOP_AT_DESK = 'STOP_AT_DESK',
  BYPASS_DESK = 'BYPASS_DESK',
  NONE = 'NONE',
}

export interface TenantBuildingSettingsOverride {
  tenant: {
    uuid: string;
    name: string;
    logoUrl: string;
  };
  availableCheckInOptions?: CheckInOption | null;
  defaultCheckInOption?: DefaultCheckInOption | null;
  enableAnonymization?: boolean;
  isAnonymizationDefault?: boolean;
  visitorInviteCampaignId?: string | null;
}

export interface BuildingSettingsDto {
  watchlist?: boolean;
  dayPass?: boolean;
  visitorGroups?: boolean;
  allowToWaiveContactInfo?: boolean;
  visitorPasses?: boolean;
  appInstanceUuid?: string;
  acknowledgmentEnabled?: boolean;
  acknowledgmentText?: string | null;
  floors?: boolean;
  defaultVisitStartTime?: string;
  defaultVisitEndTime?: string;
  maxFutureInviteValue?: number;
  maxFutureInviteUnit?: FurthestFutureInviteUnitEnum;
  availableVisitorEntryOptions?: EntryOptionsEnum[];
  defaultVisitorEntryOption?: EntryOptionsEnum | null;
  numberOfScansPerEntry?: number;
  hasAcsIntegration?: boolean;
  enableVisitorEmail?: boolean;
  enableVisitorPhone?: boolean;
  visitorContactRequirement?: VisitorContactRequirementType;
  enableAnonymization?: boolean;
  tenantEnableAnonymization?: boolean;
  isAnonymizationDefault?: boolean;
  enableLoadingDockModule?: boolean;
  enablePastVisitCheckIn?: boolean;
  availableCheckInOptions?: CheckInOption;
  defaultCheckInOption?: DefaultCheckInOption;
  tenantOverrides?: TenantBuildingSettingsOverride[];
}

export interface BuildingSettingsResponseDto {
  data: BuildingSettingsDto;
}

export interface FetchBuildingSettingsParams {
  buildingUuid: string;
}

export interface FetchBuildingSettingsSuccessDto {
  params: FetchBuildingSettingsParams;
  response: BuildingSettingsResponseDto;
}

export interface FetchBuildingSettingsErrorDto {
  params: FetchBuildingSettingsParams;
  response: Error;
  isConfigError?: boolean;
}

export interface BuildingSettingsState {
  settings: BuildingSettingsDto | null;
  loading: boolean;
  error: Error | null;
  isConfigured: boolean;
}

export type BuildingSettingsByBuilfingState = Record<string, BuildingSettingsState>;
